import controlData from '@/services/API/controlData'
import systemAPI from '@/services/API/system'
import emailCustomContentAPI from '@/services/API/emailCustomContent'
import cmsAPI from '@/services/API/cmsAPI'
import inventoryAPI from '@/services/API/inventory'
import PortausCompanyAPI from '@/services/API/portaus-company'

const fetchBlogTypes = function ({ commit, state }, locale) {
  if (state.blogTypesOutdated) {
    return cmsAPI.fetchCMSBlogTypes(locale)
      .then((blogTypes) => {
        commit('SET_BLOG_TYPES', blogTypes);
      })
  }
}

const fetchDeliveryTypes = function({ commit,state }) {
  if(state.deliveryTypes_outdated){
    return controlData.fetchDeliveryTypes().then(deliveryTypes => {
      commit('SET_DELIVERY_TYPES', deliveryTypes);
    })
  }

};

const invalidateDeliveryTypeList = function ({commit}){
  commit('INVALIDATE_DELIVERY_TYPE_LIST');
}

const fetchLocations = function({ commit,state }, code) {
  if(state.locations_outdated){
    return controlData.fetchDeliveryLocations({code}).then(locations => {
      commit('SET_LOCATIONS', locations);
    });
  }

};

const invalidateLocationList = function ({commit}){
  commit('INVALIDATE_LOCATION_LIST');
}

const fetchPaymentMethods = function({commit, state}){
  if(state.paymentMethods_outdated){
    return controlData.fetchPaymentMethods()
      .then(paymentMethods=>{
        commit('SET_PAYMENT_METHODS', paymentMethods);
      })
  }
}

const invalidatePaymentMethods = function ({commit}){
  commit('INVALIDATE_PAYMENT_METHODS');
}

const fetchPaymentTypeCategories= function({commit, state}){
  if(state.paymentTypeCategories_outdated){
    return controlData.fetchPaymentTypeCategories()
      .then(paymentTypeCategories=>{
        commit('SET_PAYMENT_TYPE_CATEGORIES', paymentTypeCategories);
      })
  }
}

const invalidatePaymentPaymentTypeCategories = function ({commit}){
  commit('INVALIDATE_PAYMENT_TYPE_CATEGORIES');
}



const fetchCompanyRoles = function ({commit, state}){
  if(state.companyRoles_outDated){
    return controlData.fetchCompanyRoles()
      .then(companyRoles=>{
        commit('SET_COMPANY_ROLES', companyRoles);
      })
  }
}

const invalidateCompanyRoles = function ({commit}){
  commit('INVALIDATE_COMPANY_ROLES');
}

const fetchCustomerClasses = function ({commit, state}){
  if(state.customerClasses_outdated){
    return controlData.fetchListValues()
      .then(listValues=>{
        commit('SET_LIST_VALUES', listValues);
      })
  }
}

const invalidateCustomerClasses = function ({commit}){
  commit('INVALIDATE_CUSTOMER_CLASSES');
}

const fetchCustomerTags = function ({commit, state}, active){
  return systemAPI.getTags('CUSTOMER',active)
    .then(tags=>{
      commit('SET_CUSTOMER_TAGS', tags);
    })
}



const fetchCurrencies = function ({commit, state}){
  if(state.currencies_outdated){
    return controlData.fetchListValues()
      .then(listValues=>{
        commit('SET_LIST_VALUES', listValues);
      })
  }
}

const invalidateCurrencies = function ({commit}){
  commit('INVALIDATE_CURRENCIES');
}

const fetchLanguages = function ({commit, state}){
  if(state.languages_outdated){
    return controlData.fetchListValues()
      .then(listValues=>{
        commit('SET_LIST_VALUES', listValues);
      })
  }
}

const invalidateLanguages = function ({commit}){
  commit('INVALIDATE_LANGUAGES');
}


const fetchCustomerCustomFieldsDefinition = function ({commit, state}){
  if(state.customerCustomFieldDefinition_outdated){
    return systemAPI.getCustomerCustomFieldDefinition()
      .then(customFields=>{
        commit('SET_CUSTOMER_CUSTOM_FIELDS_DEFINITION', customFields);
        return customFields;
      })
  }else{
    return state.customerCustomFieldDefinition;
  }
}

const invalidateCustomerCustomFieldsDefinition = function ({commit}){
  commit('INVALIDATE_CUSTOMER_CUSTOM_FIELDS_DEFINITION');
}

const fetchDeliveryScheduleExceptions = function ({commit, state}){
  if(state.deliveryScheduleExceptions_outdated){
    return controlData.fetchDeliveryScheduleExceptions()
      .then(exceptions=>{
        commit('SET_DELIVERY_SCHEDULE_EXCEPTIONS', exceptions);
        return exceptions;
      })
  }else{
    return state.deliveryScheduleExceptions;
  }
}

const invalidateDeliveryScheduleExceptions = function ({commit}){
  commit('INVALIDATE_DELIVERY_SCHEDULE_EXCEPTIONS');
}

const fetchPurchaseOrderLineCustomFieldsDefinition = function ({commit, state}){

  if(state.purchaseOrderLinesCustomFieldsDefinitionInitialized == false){
    commit('SET_CUSTOM_FIELDS_DEFINITION_INITIALIZED', true);
    return systemAPI.getProductItemsCustomFieldDefinition()
      .then(customFieldsDefinition=>{
        commit('SET_CUSTOM_FIELDS_DEFINITION', customFieldsDefinition);
      })
      .catch((err) => {
        commit('SET_CUSTOM_FIELDS_DEFINITION_INITIALIZED', false);
      })
  }
}


const fetchGLAccounts = function ({commit, state}){
  if(state.gl_accounts_outdated){
    return controlData.fetchGLAccounts()
      .then(glAccounts=>{
        commit('SET_GL_ACCOUNTS', glAccounts);
      })
  }
}

const invalidateGLAccounts = function ({commit}){
  commit('INVALIDATE_GL_ACCOUNTS');
}

const fetchTaxes = function ({commit, state}){
  if(state.taxes_outdated){
    return controlData.fetchTaxes()
      .then(taxes=>{
        commit('SET_TAXES', taxes);
      })
  }
}

const invalidateTaxes = function ({commit}){
  commit('INVALIDATE_TAXES');
}

const fetchCreditNoteTypes = function ({commit, state}){
  if(state.credit_note_types_outdated){
    return controlData.fetchCreditNoteTypes()
      .then(creditNoteTypes=>{
        commit('SET_CREDIT_NOTE_TYPES', creditNoteTypes);
      })
  }
}

const invalidateCreditNoteType = function ({commit}){
  commit('INVALIDATE_CREDIT_NOTE_TYPES');
}

const fetchRebateTypes = function ({commit, state}){
  if(state.rebate_types_outdated){
    return controlData.fetchRebateTypes()
      .then(rebateTypes=>{
        commit('SET_REBATE_TYPES', rebateTypes);
        return rebateTypes;
      })
  } else {
    return Promise.resolve(state.rebate_types);
  }
}

const invalidateRebateType = function ({commit}){
  commit('INVALIDATE_REBATE_TYPES');
}

const fetchTerritories = function ({commit, state}){
  if(state.territories_outdated){
    return controlData.fetchTerritories()
      .then(territories=>{
        commit('SET_TERRITORIES', territories);
      })
  }
}

const invalidateTerritories = function ({commit}){
  commit('INVALIDATE_TERRITORIES');
}

const fetchCountries = function ({commit, state}){
  if(state.countries_outdated==true){
    return systemAPI.fetchCountries()
      .then(countries=>{
        commit('SET_COUNTRIES', countries);
      })
    }
}

const fetchCMSConfiguration = function ({commit, state}){

  return systemAPI.getOptions('CMS')
    .then(cmsConfiguration=>{
      if(cmsConfiguration!=null && cmsConfiguration!=""){
        commit('SET_CMS_CONFIGURATION', cmsConfiguration);
      }
    })

}

const fetchMultiAgencyConfiguration = function ({commit, state}){

  return systemAPI.getOptions('MULTI_AGENCY')
    .then(multiAgencyConfiguration=>{
      if(multiAgencyConfiguration!=null && multiAgencyConfiguration!=""){
        commit('SET_MULTI_AGENCY_CONFIGURATION', multiAgencyConfiguration);
      }
    })

}

const fetchEmailCustomContent = function ({commit, state}){
  if(state.emailCustomContentOutdated){
    return emailCustomContentAPI.fetchEmailCustomContent()
      .then(customEmailContent=>{
        commit('SET_EMAIL_CUSTOM_CONTENT', customEmailContent);
        return state.emailCustomContent;
      })
  }
}

const invalidateEmailCustomContent = function ({commit}){
  commit('INVALIDATE_EMAIL_CUSTOM_CONTENT');
}

const fetchInventories = function({ commit,state }) {
  if(state.inventoriesOutdated){
    return inventoryAPI.getInventoriesV2({ all: true })
      .then(inventories => {
        commit('SET_INVENTORIES', inventories);
    });
  }

};

const invalidateInventories = function({ commit }) {
  commit('INVALIDATE_INVENTORIES');
}

const fetchPortausCompany = function ({ state, commit }) {
  if (state.portausCompaniesOutdated == true) {
    return PortausCompanyAPI.getPortausCompany()
    .then((portausCompanies) => {
      commit('SET_PORTAUS_COMPANIES', portausCompanies);
      return portausCompanies;
    });
  }
  return state.portausCompanies;
}

export default {
  fetchPortausCompany,
  invalidateInventories,
  fetchInventories,
  fetchEmailCustomContent,
  invalidateEmailCustomContent,
  fetchCountries,
  fetchDeliveryTypes,
  invalidateDeliveryTypeList,
  fetchLocations,
  invalidateLocationList,
  fetchPaymentMethods,
  invalidatePaymentMethods,
  fetchCompanyRoles,
  invalidateCompanyRoles,
  fetchCustomerClasses,
  invalidateCustomerClasses,
  fetchCustomerTags,
  fetchCurrencies,
  invalidateCurrencies,
  fetchLanguages,
  invalidateLanguages,
  fetchCustomerCustomFieldsDefinition,
  invalidateCustomerCustomFieldsDefinition,
  fetchDeliveryScheduleExceptions,
  invalidateDeliveryScheduleExceptions,
  fetchPurchaseOrderLineCustomFieldsDefinition,
  fetchGLAccounts,
  invalidateGLAccounts,
  fetchTaxes,
  invalidateTaxes,
  fetchCreditNoteTypes,
  invalidateCreditNoteType,
  fetchTerritories,
  invalidateTerritories,
  fetchPaymentTypeCategories,
  invalidatePaymentPaymentTypeCategories,
  fetchRebateTypes,
  invalidateRebateType,
  fetchCMSConfiguration,
  fetchBlogTypes,
  fetchMultiAgencyConfiguration,
};
